import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React, { cloneElement, isValidElement, useCallback } from 'react';
const InputControl = ({ onClick, disabled, readOnly, icon, className, ...other })=>{
    const handleClick = useCallback((e)=>{
        if (!disabled && !readOnly) {
            onClick(e);
        }
    }, [
        disabled,
        onClick,
        readOnly
    ]);
    const inputButtonClassName = cx('Input-button', 'Input-icon', {
        'Input-button--disabled': disabled || readOnly
    }, className);
    return /*#__PURE__*/ isValidElement(icon) ? /*#__PURE__*/ React.createElement("div", {
        className: inputButtonClassName,
        onClick: handleClick
    }, /*#__PURE__*/ cloneElement(icon, {
        disabled,
        readOnly
    })) : /*#__PURE__*/ React.createElement("span", {
        onClick: handleClick,
        className: cx(inputButtonClassName, 'Icon', `Icon--${icon}`),
        ...other
    });
};
InputControl.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    icon: PropTypes.node,
    onClick: PropTypes.func,
    readOnly: PropTypes.bool
};
export default InputControl;
